import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CustomRouteArgs, TrailArgs } from './photoTourApi';

export type TourType = 'customRoute' | 'trail';

export type TourArgs = CustomRouteArgs | TrailArgs;

export type OpenModalPayload = {
  tourType: TourType;
  tourArgs: TourArgs;
};

export type PhotoTourState = {
  isOpen: boolean;
  tourType?: TourType;
  tourArgs?: TourArgs;
  hasCustomRouteError?: boolean;
  hasTrailError?: boolean;
};

export const initialState: PhotoTourState = {
  isOpen: false
};

export const photoTourSlice = createSlice({
  name: 'photoTour',
  initialState,
  reducers: {
    resetState: (
      state: PhotoTourState,
      action: PayloadAction<{ persistKeys?: (keyof PhotoTourState)[]; initialState?: Partial<PhotoTourState> }>
    ) => {
      const defaultState: PhotoTourState = { ...initialState, ...(action.payload.initialState || {}) };
      action.payload.persistKeys?.forEach(key => {
        const persistValue = state[key];
        (defaultState[key] as typeof persistValue) = persistValue;
      });

      return defaultState;
    },
    handleOpenPhotoTour: (state, action: PayloadAction<OpenModalPayload>) => {
      const { tourType, tourArgs } = action.payload;
      state.isOpen = true;
      state.tourType = tourType;
      state.tourArgs = tourArgs;
    },
    handleClosePhotoTour: state => {
      state.isOpen = false;
    },
    handleSetCustomRouteError: (state, action: PayloadAction<boolean>) => {
      state.hasCustomRouteError = action.payload;
    },
    handleSetTrailError: (state, action: PayloadAction<boolean>) => {
      state.hasTrailError = action.payload;
    }
  }
});

export const { resetState, handleOpenPhotoTour, handleClosePhotoTour, handleSetCustomRouteError, handleSetTrailError } = photoTourSlice.actions;

export const photoTourReducer = photoTourSlice.reducer;
